import { FC } from "react";
import { ToastContainer } from "react-toastify";

import { SessionStoreProvider, useRtl } from "@ryde/redux";

import AppLanding from "./app-landing";

export const AppRootLandingSpa: FC = () => {
  const { isRtl } = useRtl();
  return (
    <SessionStoreProvider>
      <AppLanding />
      <ToastContainer rtl={isRtl} position={isRtl ? "top-left" : "top-right"} />
    </SessionStoreProvider>
  );
};
